import generatePicker from 'antd/es/date-picker/generatePicker';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import 'antd/es/date-picker/style/index';

const DatePickerWithDateFns = generatePicker<Date>(dateFnsGenerateConfig);

export default DatePickerWithDateFns;
